import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    color: var(--gray-900) !important;
    overflow-y: auto !important;
  }

  ._font-14 {
    font-size: 0.875rem;
  }

  ._font-weight-semibold {
    font-weight: 600;
  }

  ._font-weight-black {
    font-weight: 900;
  }

  [data-type="mention"], [data-action="open-profile"] {
    color: var(--blue) !important;
    text-decoration: none !important;

    &:hover {
      text-decoration: underline !important;
    }
  }
`

export default GlobalStyle
